import { FunctionComponent } from 'react'
import { DaycareGroup } from '@/types/DaycareGroup'
import Title from '@/components/_custom/Title/title'
import styles from './trusteeExports.module.scss'
import { useTranslation } from 'react-i18next'
import ExportParents from '@/components/Export/ParentsExport/ParentsExport'
import ExportOccasionalSlots from '@/components/Export/OccasionalSlotsExport/OccasionalSlotsExport'
import moment from 'moment/moment'
import ExportRegularSlots from '@/components/Export/RegularSlotsExport/RegularSlotsExport'
import ExportAbsences from '@/components/Export/AbsencesExport/AbsencesExport'
import ExportWorks from '@/components/Export/WorksExport/WorksExport'
import ExportStaffs from '@/components/Export/StaffsExport/StaffsExport'
import ExportDaycares from '@/components/Export/DaycaresExport/DaycaresExport'
import ExportTaskNotes from '@/components/Export/TaskNotesExport/TaskNotesExport.tsx'
import ExportChilds from '@/components/Export/ChildsExport/ChildsExport.tsx'
import ExportEvents from '@/components/Export/EventsExport/EventsExport.tsx'
import ExportReprintReport from '@/components/Export/ReprintReport/ReprintReport.tsx'

interface ExportProps {
    group: DaycareGroup
}

const TrusteeExports: FunctionComponent<ExportProps> = ({ group }: ExportProps) => {
    const { t } = useTranslation()

    const minDate: string = group.created
        ? moment(group.created, 'DD-MM-YYYY').format('DD-MM-YYYY')
        : moment().format('DD-MM-YYYY')

    return (
        <>
            <div className={styles.Container}>
                <div className={styles.TitleAndButton}>
                    <div className={styles.Title}>
                        <Title text={t('exports') + ' ' + t('family').toLowerCase()} />
                    </div>
                </div>
                <div className={styles.CaseContainer}>
                    <ExportOccasionalSlots daycares={group.daycares} minDate={minDate} isRpeOrLaep={false} />
                    <ExportRegularSlots daycares={group.daycares} minDate={minDate} isRpeOrLaep={false} />
                    <ExportAbsences daycares={group.daycares} minDate={minDate} isRpeOrLaep={false} />
                </div>
                <div className={styles.CaseContainer}>
                    <ExportParents daycares={group.daycares} isRpeOrLaep={false} />
                    <ExportChilds daycares={group.daycares} isRpeOrLaep={false} />
                </div>
            </div>
            <div className={styles.Container}>
                <div className={styles.TitleAndButton}>
                    <div className={styles.Title}>
                        <Title text={t('exports') + ' ' + t('staff').toLowerCase()} />
                    </div>
                </div>
                <div className={styles.CaseContainer}>
                    <ExportWorks daycares={group.daycares} minDate={minDate} />
                    <ExportStaffs daycares={group.daycares} />
                </div>
            </div>
            <div className={styles.Container}>
                <div className={styles.TitleAndButton}>
                    <div className={styles.Title}>
                        <Title text={t('exports') + ' ' + t('structure').toLowerCase()} />
                    </div>
                </div>
                <div className={styles.CaseContainer}>
                    <ExportTaskNotes daycares={group.daycares} minDate={minDate} isRpeOrLaep={false} />
                    <ExportEvents daycares={group.daycares} minDate={minDate} isRpeOrLaep={false} />
                    <ExportDaycares daycares={group.daycares} />
                    <ExportReprintReport daycares={group.daycares} minDate={minDate} fromGroup={true} />
                </div>
            </div>
        </>
    )
}

export default TrusteeExports
